import { Component, OnInit, ViewChildren, AfterViewInit, QueryList, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';
import { CategoryP } from '../../../data/cms-vod-client-api';
import { BaseComponent } from '../../../shared/commons/base-component/base.component';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SeoService } from '../../../data/seo/seo-service.service';
import { MetaService } from '../../../data/meta/meta.service';
import { isNullOrUndefined } from 'util';

declare var $: any;
declare var Glider: any;

@Component({
  selector: 'app-category-carousel',
  templateUrl: './category-carousel.component.html',
  styleUrls: ['./category-carousel.component.css']
})
export class CategoryCarouselComponent implements OnInit, AfterViewInit {

  @Input() uniqID: number;
  @ViewChildren('categoryCarouselItems') categoryCarouselItems: QueryList<any>;
  private changeSubscription: Subscription;
  $owl: any;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  categories: CategoryP[] = [];
  podcastCategory: CategoryP
 //blogCategory: CategoryP
  selectedCategoryID: number;
  items: number = 4;
  itemsDesktop: number = 4;
  itemsDesktopSmall: number = 4;
  itemsTablet: number = 4;
  itemsMobile: number = 2;
  isButtonVisible: boolean = true;
  isCategoryVisible: boolean = true;
  routerSubs: Subscription;
  bodyElement: HTMLElement;
  mainCategory: CategoryP = {};
  isDashboard: boolean;
  currentCategory: CategoryP = {};

  constructor(
    helpers: HelpersService,
    private deviceService: DeviceDetectorService,
    private restService: VodDataRestService,
    private router: Router,
    private route: ActivatedRoute,
    private seo: SeoService,
    private metaService: MetaService
  ) {
    this.bodyElement = document.getElementById('sportstv-body');

    this.isMobile = deviceService.isMobile();
    this.isTablet = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();
    //podcast category servisinden gelmeyeceği için manuel oluşturulmuştur.
    this.podcastCategory = { id: -1, name: "podcasts", urlName: "podcasts", iconUrl: 'assets/images/sportstv/podcast.png', backgroundColorCode: '#181818' };
    // this.blogCategory = { id: -2, name: "blogs", urlName: "blog", iconUrl: 'assets/images/sportstv/blog.png', backgroundColorCode: '#181818' };
    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isDashboard = this.router.url.includes('dashboard');
        if (this.uniqID == 1) {
          this.selectedCategoryID = +this.route.snapshot.paramMap.get('id');
        }
        else if (this.uniqID == 2 && this.isDashboard) {
          this.selectedCategoryID = +this.route.children[0].snapshot.paramMap.get('id');
        }

      }
    });
  }

  ngOnInit() {
    this.isDashboard = this.router.url.includes('dashboard');

    if (this.uniqID == 1) {
      this.selectedCategoryID = +this.route.snapshot.paramMap.get('id');
    }
    else if (this.uniqID == 2 && this.isDashboard) {
      this.selectedCategoryID = +this.route.children[0].snapshot.paramMap.get('id');
    }


  }

  ngAfterViewInit() {

    if (this.isMobile || this.isTablet) {
      let element = document.getElementById('category-container-' + this.uniqID).style.width = '85%';
    }

    this.restService.getActiveCategories().subscribe(data => {
      this.categories = data;
      // this.findSelectedCategory();

      this.categories.splice(3, 0, this.podcastCategory);
      //this.categories.splice(4, 0, this.blogCategory);

      if (this.categories == null || this.categories.length == 0) {
        this.isCategoryVisible = false;
        this.isButtonVisible = false;
      }
      else {
        this.isCategoryVisible = true;
        this.mainCategory = this.categories.find(item => item.main == true);
        localStorage.setItem('main_cat_id', this.mainCategory.id + '')

        if (this.selectedCategoryID == 0 && this.mainCategory) {
          this.selectedCategoryID = this.mainCategory.id;
          this.currentCategory = this.mainCategory;
          this.changeBackgroundColor(false);
        }
        else {
          this.currentCategory = this.categories.find(item => item.id == this.selectedCategoryID);
          this.changeBackgroundColor(false);
        }
        if (this.uniqID == 1) {
          localStorage.setItem('selected_cat_id', this.selectedCategoryID + '')
        }
        if (this.isMobile) {
          if (this.categories.length <= this.itemsMobile) {
            this.isButtonVisible = false;
          }
          else {
            this.isButtonVisible = true;
          }
        }
        else if (this.isTablet) {
          if (this.categories.length <= this.itemsTablet) {
            this.isButtonVisible = false;
          }
          else {
            this.isButtonVisible = true;
          }
        }
        else {
          if (this.categories.length <= this.items) {
            this.isButtonVisible = false;
          }
          else {
            this.isButtonVisible = true;
          }
        }
        this.carouselInit();


      }

    })
  }

  // findSelectedCategory() {
  //   if (this.selectedCategoryID != 0 && this.selectedCategoryID != -1) {
  //     this.changeBackgroundColor(this.categories.find(item => item.id == this.selectedCategoryID))
  //   }
  //   else {
  //     this.changeBackgroundColor();
  //   }
  // }

  changeBackgroundColor(fromChange: boolean) {
    // if (!fromChange) {
    //   console.log("currentCat1 init:");
    //   this.seo.generateTags({
    //     title: this.currentCategory.name,
    //     description: 'Sporun adresi sportstv',
    //     image: this.currentCategory.iconUrl,
    //   });

    // }
    // else {
    // console.log("currentCat2:", this.currentCategory);
    // }
    if (!!this.currentCategory) {
      this.bodyElement.style.backgroundColor = this.currentCategory.backgroundColorCode;
      this.seo.generateTags({
        title: this.currentCategory.name,
        description: this.currentCategory.description,
        image: this.currentCategory.iconUrl,
        url: this.router.url,

      });
    }
    else {
      this.bodyElement.style.backgroundColor = this.mainCategory.backgroundColorCode;
    }
    if (localStorage.getItem('backgroundcolor')) {
      localStorage.removeItem('backgroundcolor')
    }
    localStorage.setItem('backgroundcolor', this.bodyElement.style.backgroundColor);
  }

  carouselInit() {
    this.changeSubscription = this.categoryCarouselItems.changes.subscribe(t => {
      this.$owl = new Glider(document.querySelector("#category-carousel-" + this.uniqID), {
        slidesToShow: this.items,
        // itemsDesktop: [1600, this.itemsDesktop],
        // itemsDesktopSmall: [991, this.itemsDesktopSmall],
        // itemsTablet: [767, this.itemsTablet],
        // itemsMobile: [479, this.itemsMobile],
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: this.items,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: this.itemsDesktopSmall,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 479,
            settings: {
              slidesToShow: this.itemsTablet,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 0,
            settings: {
              slidesToShow: this.itemsMobile,
              slidesToScroll: 1,
            }
          },
        ],
        arrows: {
          prev: `#cat-glider-prev-${this.uniqID}`,
          next: `#cat-glider-next-${this.uniqID}`
        },
        rewind: true,
        // draggable: !this.isDesktop,
        draggable: true,
        duration: 1.2,
        dragVelocity: 1,
      })
    });

    this.goToItem()

  }

  goToItem() {

    if (this.selectedCategoryID != 0) {
      setTimeout(() => {
        let index = this.categories.findIndex(item => item.id == this.selectedCategoryID)
        this.$owl.scrollItem(index)
        // this.$owl.trigger('to.owl.carousel', [index, 300])

      }, 100);

    }
  }


  prevItem() {
    this.$owl.trigger('prev.owl.carousel', [300]); //300 speed param.
  }

  nextItem() {
    this.$owl.trigger('next.owl.carousel', [300]);
  }

  routeDashboard(category: CategoryP) {
    //this.router.navigate(['/dashboard', category.id, category.urlName]);
    //console.log("route dashboard")
    this.currentCategory = category;
    this.changeBackgroundColor(true);

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/category-carousel/category-carousel.component.ts